import { MenuItem, TextField } from '@mui/material';
import { useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useUserPermissions } from 'shared/hooks';
import { useQueryContracts } from 'shared/queries/query-contracts';
import { ContractRouteParams } from 'shared/types/routing';
import { compareDates } from 'shared/utility';

export function ContractSelection() {
  const { masterCustomer, abgBrand, contractId } = useParams<ContractRouteParams>();
  const { contracts } = useQueryContracts({ brand: abgBrand, customer: masterCustomer });
  const history = useHistory();
  const userPermissions = useUserPermissions();
  const hasControllerPermission = userPermissions.includes('abg-retail.controller');

  const contractOptions = useMemo(() => {
    let contractsToReturn = contracts || [];
    if (hasControllerPermission) {
      contractsToReturn = contractsToReturn.filter(
        c =>
          (c.approvalStatus === 'Approved' || !c.approvalStatus) &&
          (!c.endDate || compareDates(new Date(c.endDate), new Date()) !== 1)
      );
    }
    return contractsToReturn.map(contract => ({
      label: `${contract.brand} ${contract.billToCode} ${contract.originalDocumentName}`,
      path: contract.id,
    }));
  }, [contracts, hasControllerPermission]);

  if (
    !contracts ||
    (hasControllerPermission &&
      contracts?.every(
        c => c.approvalStatus !== 'Approved' && (!c.endDate || compareDates(new Date(c.endDate), new Date()) !== 1)
      )) ||
    (!hasControllerPermission && contracts.length === 0)
  ) {
    return null;
  }

  return (
    <TextField
      size='small'
      id='contract-selection-select'
      label='Contract Selection'
      select
      value={contractId || ''}
      fullWidth
      onChange={event => {
        const contractId = event.target.value;
        history.push(ROUTES.toContract({ masterCustomer, abgBrand, contractId }));
      }}
    >
      {contractOptions.map(({ label, path }) => (
        <MenuItem key={path} value={path}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  );
}
